export enum StatusOffer {
	Sold = 'Vendido',
	Soon = 'Em Breve',
	Closed = 'Encerrado',
	Available = 'Disponível',
}
